import React from 'react'
import './Pdframe.css'

const PdframeContainer = ({ containerObject, dataZone, templateName, contentId }) => {
    return (
        <div className={`${containerObject.attributes.class}`}>
            <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row `}>
                {containerObject.articles && containerObject.articles ? containerObject.articles.map((iframe) => {
                     return (
                        <>
                            <div>
                                <iframe className={`${iframe.attributes.class}`}src={iframe.attributes.linkUrl} width="" height="" frameborder="0.5">
                                </iframe>
                            </div>
                        </>
                    )
                }) : ''}
                    {/* <iframe src="https://drive.google.com/file/d/1jIr0Ibj3Bg4-zCAhBuuMeYChuEMhDcB8/preview"></iframe> */}
    </div>
        </div>
    )
}

export default PdframeContainer